import { FormikValues } from 'formik'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'

import { Button } from 'components/button'
import { Flex } from 'components/flex'
import { Form } from 'components/form'
import { PasswordInput } from 'components/passwordInput'

import { withAdminLayout } from 'hoc/withAdminLayout'

import { browserHistory } from 'navigation/browserHistory'

import { GlobalState } from 'store'
import { updatePassword } from 'store/user/actions'

import { passwordRegex } from 'utils/regexUtils'

import { ContainerButtons, MainContainer } from './styled'

function UpdatePassword(): JSX.Element {
  const { t } = useTranslation(['pages'])

  const dispatch = useDispatch()

  const { updatePasswordInProgress } = useSelector(
    (state: GlobalState) => state.user
  )

  const initialValues = {
    currentPassword: '',
    password: '',
    passwordConfirmation: ''
  }

  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string().required('required'),
    password: Yup.string()
      .matches(passwordRegex, 'password.rules')
      .required('required'),
    passwordConfirmation: Yup.string()
      .required('required')
      .oneOf([Yup.ref('password')], 'passwordMatch')
  })

  function _resetPassword(data: FormikValues) {
    dispatch(
      updatePassword({
        password: data.password
      })
    )
  }

  document.title = 'Configurações - Open Insurance'

  return (
    <>
      <h4>{t('pages:updatePassword.title')}</h4>

      <MainContainer>
        <Form
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => _resetPassword(values)}
        >
          <label className="title">{t('pages:updatePassword.title')}</label>

          <Flex direction="column" align="center">
            <PasswordInput
              label="SENHA ATUAL"
              name="currentPassword"
              placeholder={t('pages:updatePassword.form.currentPassword')}
              autoComplete="off"
              showStrength={false}
            />

            <PasswordInput
              label="NOVA SENHA"
              name="password"
              placeholder={t('pages:updatePassword.form.password')}
              autoComplete="new-password"
            />

            <PasswordInput
              label="CONFIRMAÇÃO DE SENHA"
              name="passwordConfirmation"
              placeholder={t('pages:updatePassword.form.passwordConfirmation')}
              autoComplete="new-password"
              showStrength={false}
            />

            <ContainerButtons>
              <Button
                type="submit"
                inProgress={updatePasswordInProgress}
                backgroundColor="primary"
              >
                {t('pages:updatePassword.form.submitButton')}
              </Button>
              <Button
                inProgress={updatePasswordInProgress}
                backgroundColor="primary"
                color="primary"
                variant="outline"
                onClick={() => browserHistory.goBack()}
              >
                Voltar
              </Button>
            </ContainerButtons>
          </Flex>
        </Form>
      </MainContainer>
    </>
  )
}

export const UpdatePasswordPage = withAdminLayout(UpdatePassword)
